import script from "./ProjectSection.vue?vue&type=script&setup=true&lang=js"
export * from "./ProjectSection.vue?vue&type=script&setup=true&lang=js"

import "./ProjectSection.vue?vue&type=style&index=0&id=751d94cc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-751d94cc"]])

export default __exports__